import { Link } from 'react-router-dom';

const categoryList = [
  {
    slug: 'ai-creation',
    name: 'AIツール活用',
    description: 'CursorやClaude、ChatGPTを実際に使った記録。紹介ではなく、使った結果を書く。',
    icon: 'ri-robot-line',
    count: 8,
  },
  {
    slug: 'build-log',
    name: '制作フロー',
    description: '仕様書化・プロンプト設計・実装フローなど、作るプロセスを整理した記事。',
    icon: 'ri-flow-chart',
    count: 5,
  },
  {
    slug: 'ai-creation',
    name: 'UI再現',
    description: '既存のUIをAIで再現する実験ログ。詰まった箇所と解決策を全部残す。',
    icon: 'ri-layout-line',
    count: 4,
  },
  {
    slug: 'productivity',
    name: '比較検証',
    description: 'ツールやアプローチを実際に比べた記録。主観と数字を両方書く。',
    icon: 'ri-scales-line',
    count: 3,
  },
  {
    slug: 'productivity',
    name: 'プロンプト・仕様書',
    description: '再利用できるプロンプトや仕様書のテンプレートと、その設計思想。',
    icon: 'ri-file-text-line',
    count: 6,
  },
  {
    slug: 'build-log',
    name: '運営メモ',
    description: 'このサイト自体の制作・運営記録。判断・迷い・失敗も含めて残す。',
    icon: 'ri-edit-line',
    count: 4,
  },
];

export function CategorySection() {
  return (
    <section className="py-14 sm:py-20 bg-[#FDFAF6]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">

        {/* Section header */}
        <div className="flex items-baseline justify-between mb-8 sm:mb-10">
          <div>
            <p
              className="text-xs font-semibold tracking-widest uppercase text-[#5B7B6F] mb-2"
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              Categories
            </p>
            <h2
              className="text-xl sm:text-2xl font-bold text-[#2C2416]"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              カテゴリ一覧
            </h2>
          </div>
          <Link
            to="/categories"
            className="text-xs text-[#7A6E62] hover:text-[#2C2416] transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            すべて見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {categoryList.map((cat, index) => (
            <Link
              key={`${cat.slug}-${index}`}
              to={`/categories/${cat.slug}`}
              className="flex items-start gap-4 p-4 sm:p-5 border border-[#E8E0D5] rounded-lg hover:border-[#C8BFB5] hover:bg-[#F8F3EC] transition-all cursor-pointer group"
            >
              <div className="w-9 h-9 flex items-center justify-center flex-shrink-0 bg-[#F0EBE3] rounded-md group-hover:bg-[#E8E0D5] transition-colors">
                <i className={`${cat.icon} text-base text-[#5B7B6F]`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 mb-1">
                  <h3
                    className="text-sm font-semibold text-[#2C2416] group-hover:text-[#5B7B6F] transition-colors"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {cat.name}
                  </h3>
                  <span
                    className="text-xs text-[#9A8E84] flex-shrink-0"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {cat.count}本
                  </span>
                </div>
                <p
                  className="text-xs text-[#7A6E62] leading-relaxed"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
}
